module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"geographicalSurveyInstitute":"国土地理院","attribution":"河川・流域界：国土交通省国土政策局「国土数値情報流域界・非集水域S52 河川H18～H21」をもとに(株)建設技術研究所が加工"},"en":{"geographicalSurveyInstitute":"Geographical Survey Institute","attribution":"River and watershed delineation based on MLIT (Ministry of Land, Infrastructure, Transport and Tourism) data processed by CTI Engineering Co., Ltd."}}')
  delete Component.options._Ctor
}
